import React from "react";
import "./Spinner.scss";

export default function Spinner() {
  return (
    <div className="spinner-container">
      <div className="loader"></div>
    </div>
  );
}
